import _Accordion from '@tencent/odc-accordion';
import _AlertGroup from '@tencent/odc-alert-group';
import _Card, { ICardProps } from '@tencent/odc-card';
import _CardBox, { ICardBoxProps } from '@tencent/odc-card-box';
import _Coachmark, { ICoachmarkProps } from '@tencent/odc-coachmark';
import _Corner, { ICornerProps } from '@tencent/odc-corner';
import _Divider, { IDividerProps } from '@tencent/odc-divider';
import _EllipsisMiddle, { IEllipsisMiddleProps } from '@tencent/odc-ellipsis-middle';
import _Figure, { IFigureProps } from '@tencent/odc-figure';
import _Flex, { IFlexProps } from '@tencent/odc-flex';
import _Frame, { IFrameProps } from '@tencent/odc-frame';
import _HelpTips, { IHelpTipsProps } from '@tencent/odc-help-tips';
import _HrBox from '@tencent/odc-hr-box';
import _LabelInput, { ILabelInputProps, ILabelInputRef } from '@tencent/odc-label-input';
import _LabelText, { ILabelTextProps, ILabelTextItemProps } from '@tencent/odc-label-text';
import _Link, { ILinkProps } from '@tencent/odc-link';
import _NumberInput, { INumberInputProps } from '@tencent/odc-number-input';
import _Pen, { IPenProps } from '@tencent/odc-pen';
import _Progress, { IProgressProps } from '@tencent/odc-progress';
import _SelectionSearch, { ISelectionSearchProps } from '@tencent/odc-selection-search';
import _Skeleton, { ISkeletonProps } from '@tencent/odc-skeleton';
import _Steps, { IStepsPanelProps, IStepsProps, IStepsDataProps, StepsContext } from '@tencent/odc-steps';
import _Slick, { ISlickProps } from '@tencent/odc-slick';

import _Sidebar, { ISidebarProps, ISidebarDataType, SidebarItem, SidebarList } from '@tencent/odc-sidebar';
import _Tag, { ITagProps } from '@tencent/odc-tag';
import _Text, { ITextProps } from '@tencent/odc-text';
import _TextList, { ITextListProps } from '@tencent/odc-text-list';
import _Titlebar, { ITitlebarProps } from '@tencent/odc-titlebar';
import _Toolbar, { IToolbarProps } from '@tencent/odc-toolbar';
import _Twins, { ITwinsProps } from '@tencent/odc-twins';
import _Metas, { IMetasProps } from '@tencent/odc-metas';
import _Meta, { IMetaProps } from '@tencent/odc-meta';
import _MetaName, { IMetaNameProps } from '@tencent/odc-meta-name';
import _MetaContent, { IMetaContentProps } from '@tencent/odc-meta-content';

import _MetaInput, { IMetaInputProps } from '@tencent/odc-meta-input';
import _MetaInputPanel, { IMetaInputPanelProps } from '@tencent/odc-meta-input-panel';
import _MetaFormGroup, { IMetaFormGroupProps } from '@tencent/odc-meta-form-group';
import _MetaSwitchPanel, { IMetaSwitchPanelProps } from '@tencent/odc-meta-switch-panel';
import _MetaTabs, { IMetaTabsProps } from '@tencent/odc-meta-tabs';
import _MetaTabPanel, { IMetaTabPanelProps } from '@tencent/odc-meta-tab-panel';
import _MetasSecondary, { IMetasSecondaryProps } from '@tencent/odc-metas-secondary';
import _InstantText, { IInstantTextProps } from '@tencent/odc-instant-text';

import _CheckTabsDefault, { ICheckTabsProps, ICheckTabsPanelProps } from '@tencent/odc-check-tabs';

import _SelectChip, { ISelectChipProps } from '@tencent/odc-select-chip';
import _PullDownChip, { IPullDownChipProps } from '@tencent/odc-pull-down-chip';
import _ProDialogBody, { IProDialogBodyProps, ProDialogProps } from '@tencent/odc-pro-dialog-body';

import versionInfo from './info';
import feedback from './feedback';
import devTools from './devtools';
import { token, CSSTokens, genToken } from './utils';

/**
 * 手风琴组件
 * @see [Doc](https://onedesign.woa.com/pro/components/odc-accordion)
 */
const ODC_ACCORDION = _Accordion;

const { Accordion } = ODC_ACCORDION;
const { AccordionPanel } = ODC_ACCORDION;

/**
 * 提示条组 组件
 * @see [Doc](https://onedesign.woa.com/pro/components/odc-alert-group)
 */
const AlertGroup = _AlertGroup;

/**
 * 卡片组件
 * @see [Doc](https://onedesign.woa.com/pro/components/odc-card)
 */
const Card = _Card;
/**
 * 水平盒子
 * @deprecated 请使用 Flex 或 Toolbar 替代。可以联系 UI 开发同学进行替换
 * @see [Doc](https://onedesign.woa.com/pro/components/odc-hr-box)
 */
const HrBox = _HrBox;
/**
 * 数字输入框
 * @see [Doc](https://onedesign.woa.com/pro/components/odc-number-input)
 */
const NumberInput = _NumberInput;
/**
 * Frame 组件，用于模拟 Figma 中的 Frame 框架
 * @see [Doc](https://onedesign.woa.com/pro/components/odc-frame)
 */
const Frame = _Frame;
/**
 * Flex 组件，用于模拟 CSS 中 的 Flex 布局
 * @see [Doc](https://onedesign.woa.com/pro/components/odc-flex)
 */
const Flex = _Flex;
/**
 * 标签输入框
 * @see [Doc](https://onedesign.woa.com/pro/components/odc-label-input)
 */
const LabelInput = _LabelInput;
/**
 * 集装箱
 * @see [Doc](https://onedesign.woa.com/pro/components/odc-card-box)
 */
const CardBox = _CardBox;
/**
 * 角标
 * @see [Doc](https://onedesign.woa.com/pro/components/odc-corner)
 */
const Corner = _Corner;
/**
 * 小铅笔
 * @see [Doc](https://onedesign.woa.com/pro/components/odc-pen)
 */
const Pen = _Pen;
/**
 * 长文本中间省略
 * @see [Doc](https://onedesign.woa.com/pro/components/odc-ellipsis-middle)
 */
const EllipsisMiddle = _EllipsisMiddle;
/**
 * 图片
 * @see [Doc](https://onedesign.woa.com/pro/components/odc-figure)
 */
const Figure = _Figure;
/**
 * 指引标记
 * @see [Doc](https://onedesign.woa.com/pro/components/odc-coachmark)
 */
const Coachmark = _Coachmark;
/**
 * 标签文字组合
 * @see [Doc](https://onedesign.woa.com/pro/components/odc-label-text)
 */
const LabelText = _LabelText;
/**
 * 链接
 * @see [Doc](https://onedesign.woa.com/pro/components/odc-link)
 */
const Link = _Link;
/**
 * 标签
 * @see [Doc](https://onedesign.woa.com/pro/components/odc-tag)
 */
const Tag = _Tag;
/**
 * 文本
 * @see [Doc](https://onedesign.woa.com/pro/components/odc-text)
 */
const Text = _Text;
/**
 * 文字列表
 * @see [Doc](https://onedesign.woa.com/pro/components/odc-text-list)
 */
const TextList = _TextList;
/**
 * 分隔线
 * @see [Doc](https://onedesign.woa.com/pro/components/odc-divider)
 */
const Divider = _Divider;
/**
 * 标题
 * @see [Doc](https://onedesign.woa.com/pro/components/odc-titlebar)
 */
const Titlebar = _Titlebar;
/**
 * 工具条
 * @see [Doc](https://onedesign.woa.com/pro/components/odc-toolbar)
 */
const Toolbar = _Toolbar;
/**
 * 双胞胎
 * @see [Doc](https://onedesign.woa.com/pro/components/odc-twins)
 */
const Twins = _Twins;
/**
 * 提示
 * @see [Doc](https://onedesign.woa.com/pro/components/odc-help-tips)
 */
const HelpTips = _HelpTips;
/**
 * spaui-select 的搜索框扩展
 * @see [Doc](https://onedesign.woa.com/pro/components/odc-selection-search)
 */
const SelectionSearch = _SelectionSearch;
/**
 * 滑动器
 * @see [Doc](https://onedesign.woa.com/pro/components/odc-slick)
 */
const Slick = _Slick;
/**
 * 左侧侧边栏
 * @see [Doc](https://onedesign.woa.com/pro/components/odc-slick)
 */
const Sidebar = _Sidebar;
/**
 * 滑动器
 * @see [Doc](https://onedesign.woa.com/pro/components/odc-slick)
 */
const Progress = _Progress;
/**
 * 骨架屏
 * @see [Doc](https://onedesign.woa.com/pro/components/odc-skeleton)
 */
const Skeleton = _Skeleton;

/**
 * Meta 组合
 * @see [Doc](https://onedesign.woa.com/pro/components/odc-metas)
 */
const Metas = _Metas;
/**
 * Meta 表单项
 * @see [Doc](https://onedesign.woa.com/pro/components/odc-meta)
 */
const Meta = _Meta;
/**
 * Meta 表单标题
 * @see [Doc](https://onedesign.woa.com/pro/components/odc-meta-name)
 */
const MetaName = _MetaName;
/**
 * Meta 表单内容
 * @see [Doc](https://onedesign.woa.com/pro/components/odc-meta-content)
 */
const MetaContent = _MetaContent;

/**
 * Meta 输入框
 * @see [Doc](https://onedesign.woa.com/pro/components/odc-meta-input)
 */
const MetaInput = _MetaInput;

/**
 * Meta 输入框组合
 * @see [Doc](https://onedesign.woa.com/pro/components/odc-meta-input-panel)
 */
const MetaInputPanel = _MetaInputPanel;

/**
 * Meta 表单组合
 * @see [Doc](https://onedesign.woa.com/pro/components/odc-meta-form-group)
 */
const MetaFormGroup = _MetaFormGroup;

/**
 * Meta 开关组合
 * @see [Doc](https://onedesign.woa.com/pro/components/odc-meta-switch-panel)
 */
const MetaSwitchPanel = _MetaSwitchPanel;

/**
 * Meta Tabs 组合
 * @see [Doc](https://onedesign.woa.com/pro/components/odc-meta-tabs)
 */
const MetaTabs = _MetaTabs;

/**
 * Meta TabPanel 面板
 * @see [Doc](https://onedesign.woa.com/pro/components/odc-meta-tab-panel)
 */
const MetaTabPanel = _MetaTabPanel;

/**
 * Meta 表单内容
 * @see [Doc](https://onedesign.woa.com/pro/components/odc-metas-secondary)
 */
const MetasSecondary = _MetasSecondary;

/**
 * Meta 即时编辑
 * @see [Doc](https://onedesign.woa.com/pro/components/odc-instant-text)
 */
const InstantText = _InstantText;

/**
 * 单选 Tabs
 * @see [Doc](https://onedesign.woa.com/pro/components/odc-check-tabs)
 */
const { CheckTabs, CheckTabsPanel } = _CheckTabsDefault;

/**
 * 选择标签 SelectChip
 * @see [Doc](https://onedesign.woa.com/pro/components/odc-select-chip)
 */
const SelectChip = _SelectChip;

/**
 * 下拉标签 PullDownChip
 * @see [Doc](https://onedesign.woa.com/pro/components/odc-pull-down-chip)
 */
const PullDownChip = _PullDownChip;

/**
 * 投放3.0弹窗主体 ProDialog 的 body
 * @see [Doc](https://onedesign.woa.com/pro/components/odc-pro-dialog-body)
 */
const ProDialogBody = _ProDialogBody;


const ODC_STEPS = _Steps;
/**
 * 步骤条
 * @see [Doc](https://onedesign.woa.com/pro/components/odc-steps)
 */
const { Steps } = ODC_STEPS;
const { StepsPanel } = ODC_STEPS;

if (typeof window === 'object' && window) {
  if (typeof window.__ODC_FEEDBACK__ === 'undefined') {
    window.__ODC_FEEDBACK__ = feedback;
  }
}

// 内网环境 + alpha-version = 加载开发工具
devTools();

export default {
  Accordion,
  AlertGroup,
  Card,
  CardBox,
  CheckTabs,
  CheckTabsPanel,
  Corner,
  Coachmark,
  Divider,
  EllipsisMiddle,
  Figure,
  SelectChip,
  PullDownChip,
  Frame,
  Flex,
  HelpTips,
  HrBox,
  LabelText,
  LabelInput,
  Link,
  InstantText,
  NumberInput,
  Pen,
  Progress,
  ProDialogBody,
  ProDialogProps,
  SelectionSearch,
  Slick,
  Sidebar,
  SidebarItem,
  SidebarList,
  Skeleton,
  Steps,
  Tag,
  Text,
  TextList,
  Titlebar,
  Toolbar,
  Twins,
  Metas,
  Meta,
  MetaName,
  MetaContent,
  MetaInput,
  MetaInputPanel,
  MetaFormGroup,
  MetaSwitchPanel,
  MetaTabs,
  MetaTabPanel,
  MetasSecondary,
  feedback,
  token,
  genToken,
  versionInfo,
};

export {
  Accordion,
  AccordionPanel,
  AlertGroup,
  Card,
  ICardProps,
  CardBox,
  ICardBoxProps,
  CheckTabs,
  CheckTabsPanel,
  ICheckTabsProps,
  ICheckTabsPanelProps,
  Corner,
  ICornerProps,
  Coachmark,
  ICoachmarkProps,
  Divider,
  IDividerProps,
  EllipsisMiddle,
  IEllipsisMiddleProps,
  Figure,
  IFigureProps,
  Frame,
  IFrameProps,
  Flex,
  IFlexProps,
  HelpTips,
  IHelpTipsProps,
  HrBox,
  LabelText,
  ILabelTextProps,
  ILabelTextItemProps,
  LabelInput,
  ILabelInputProps,
  ILabelInputRef,
  Link,
  ILinkProps,
  InstantText,
  IInstantTextProps,
  NumberInput,
  INumberInputProps,
  Pen,
  IPenProps,
  Progress,
  IProgressProps,
  ProDialogBody,
  IProDialogBodyProps,
  ProDialogProps,
  SelectionSearch,
  ISelectionSearchProps,
  Slick,
  ISlickProps,
  Sidebar,
  SidebarItem,
  SidebarList,
  ISidebarProps,
  ISidebarDataType,
  Steps,
  StepsPanel,
  IStepsProps,
  IStepsPanelProps,
  IStepsDataProps,
  StepsContext,
  Skeleton,
  ISkeletonProps,
  Tag,
  ITagProps,
  Text,
  ITextProps,
  TextList,
  ITextListProps,
  Titlebar,
  ITitlebarProps,
  Toolbar,
  IToolbarProps,
  Twins,
  ITwinsProps,
  Metas,
  IMetasProps,
  Meta,
  IMetaProps,
  MetaName,
  IMetaNameProps,
  MetaContent,
  IMetaContentProps,
  MetaInput,
  IMetaInputProps,
  MetaInputPanel,
  IMetaInputPanelProps,
  MetaFormGroup,
  IMetaFormGroupProps,
  MetaSwitchPanel,
  IMetaSwitchPanelProps,
  MetaTabs,
  IMetaTabsProps,
  MetaTabPanel,
  IMetaTabPanelProps,
  MetasSecondary,
  IMetasSecondaryProps,
  feedback,
  token,
  CSSTokens,
  genToken,
  versionInfo,
  SelectChip,
  ISelectChipProps,
  PullDownChip,
  IPullDownChipProps,
  // ChipGroup,
  // IChipGroupProps,
};
